const formatPhoneNumber = (phoneNumber) => {
  // Convert to string and remove any non-digit characters
  const cleaned = String(phoneNumber).replace(/\D/g, '');
  
  // Check if we have exactly 10 digits
  if (cleaned.length !== 10) {
    return phoneNumber; // Return original if not valid
  }
  
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

export default formatPhoneNumber;